import React, { useState, useEffect } from 'react';
import { HashLink } from 'react-router-hash-link';
import { useDishes } from '../DishesContext';

function CategoryMenu({...props}) {
  const [selectedFilter, setSelectedFilter] = useState(0);
  const [shouldScroll, setShouldScroll] = useState(false);
  const items = useDishes()
  const ref = React.createRef()
  const wrapperRef = React.createRef()
  const [isDown, setIsDown] = useState(false);
  const [startX, setStartX] = useState(null);
  const [transLeftOffset, setTransLeftOffsetsetStartX] = useState(null);

  const settings = {
    dragSpeed: 1.25,
  }

  const intValueOf = (el) => {
    return parseInt(el.replace('translateX(', '').replace('px)',''), 10)
  } 
  
  const handleMouseDown = (e) => {
    const draggableMenu = ref.current
    e.persist()
  
    draggableMenu.classList.add('active')
  
    const _startX = e.pageX - draggableMenu.offsetLeft
    const _transLeftOffset = intValueOf(draggableMenu.firstChild.style.transform)
    setIsDown(true) 
    setStartX(_startX)
    setTransLeftOffsetsetStartX(_transLeftOffset)

    const x = e.pageX - draggableMenu.offsetLeft
    const walk = (x - _startX) * settings.dragSpeed

    draggableMenu.firstChild.style.cssText = `
      transform: translateX(${_transLeftOffset + walk}px);
      transition: transform 0.0s ease-in-out;
    `;
  }

  const handleMouseLeave = (e) => {
    handleSnap()
  }
  
  const handleMouseUp = (e) => {
    handleSnap();
  }
  
  const handleMouseMove = (e) => {
    const draggableMenu = ref.current
  
  
    if(!isDown) return 
    e.preventDefault()
  
    const x = e.pageX - draggableMenu.offsetLeft
    const walk = (x - startX) * settings.dragSpeed
    
    draggableMenu.firstChild.style.transform = `translateX(${transLeftOffset + walk}px)`;
  }
  
  const handleSnap = () => {
    const draggableMenu = ref.current;
    const navigationWrapper = wrapperRef.current;
  
    setIsDown(false);
    draggableMenu.classList.remove('active')
  
    const tempThresholdOffset = intValueOf(draggableMenu.firstChild.style.transform)
    const scrollableWrapper = navigationWrapper.offsetWidth; 
    const  scrollableWrapperOverflow = scrollableWrapper - draggableMenu.offsetWidth;
    const end = -(scrollableWrapperOverflow);


    if (tempThresholdOffset <= end || tempThresholdOffset > 0) {
      draggableMenu.firstChild.style.cssText = `
        transform: translateX(${ tempThresholdOffset < end ? end : 0}px);
        transition: transform 0.5s cubic-bezier(.25,.72,.51,.96);s
      `;
    }
  }

  const selectFilter = (index) => {
    setSelectedFilter(index);
  };

  useEffect(() => {
    const draggableMenu = ref.current;
    const navigationWrapper = wrapperRef.current;

    if (navigationWrapper.offsetWidth > draggableMenu.offsetWidth) setShouldScroll(true);

  }, [items])


  return (

    <nav className='category-filters m-t-12'>
      <div
        className={`category-filters__container ${!shouldScroll ? "not-scrollable" : ""}`}
        ref={ref}
        onMouseDown={shouldScroll && handleMouseDown}
        onMouseLeave={shouldScroll && handleMouseLeave}
        onMouseUp={shouldScroll && handleMouseUp}
        onMouseMove={shouldScroll && handleMouseMove}
      >
        <div
          className='category-filters__wrapper'
          ref={wrapperRef}
          style={{
            transform: 'translateX(0px)'
          }}>
          {items.map((category, index) => (
            <div key={category.key} className={`category-filters__menu-item ${index === selectedFilter ? "selected" : ""}`}>
              <HashLink
                smooth
                to={`#${category.key}`}
                onClick={() => selectFilter(index)}
                replace
              >
                {category.category_name}
              </HashLink>
            </div>
          ))}

        </div>
      </div>
    </nav>
  )
}

export default CategoryMenu;
